export default __webpack_public_path__ + "00c9898d8dd8bf7b46f7a6a57810890c.png";